import { getBoundsOfItem } from "./findBoundsOfItem";

export function findBoundsOfArrayOfItems(itemArray) {
  let xMinBoundsArray = [];
  let xMaxBoundsArray = [];
  let yMaxBoundsArray = [];
  let yMinBoundsArray = [];
  let centroidXArray = [];
  let centroidYArray = [];

  itemArray.forEach((item) => {
    let itemBounds = getBoundsOfItem(item);
    xMinBoundsArray.push(itemBounds.left);
    xMaxBoundsArray.push(itemBounds.right);
    yMaxBoundsArray.push(itemBounds.bottom);
    yMinBoundsArray.push(itemBounds.top);
    centroidXArray.push(itemBounds.centerX);
    centroidYArray.push(itemBounds.centerY);
  });

  // sort those bounds arrays
  let leftMostBound = Math.min(...xMinBoundsArray);
  let rightMostBound = Math.max(...xMinBoundsArray);
  let bottomMostBound = Math.max(...yMaxBoundsArray);
  let topMostBound = Math.min(...yMaxBoundsArray);
  let width = rightMostBound - leftMostBound;
  let height = bottomMostBound - topMostBound;
  let geomBoundsCenterX = width / 2 + leftMostBound;
  let geomBoundsCenterY = height / 2 + topMostBound;

  let centroidXSum = centroidXArray.reduce(
    (partialSum, a) => partialSum + a,
    0
  );
  let centroidX = centroidXSum / itemArray.length;
  let centroidYSum = centroidYArray.reduce(
    (partialSum, a) => partialSum + a,
    0
  );
  let centroidY = centroidYSum / itemArray.length;

  return {
    right: rightMostBound,
    left: leftMostBound,
    bottom: bottomMostBound,
    top: topMostBound,
    width: width,
    height: height,
    geomBoundsCenterX: geomBoundsCenterX,
    geomBoundsCenterY: geomBoundsCenterY,
    centroidX: centroidX,
    centroidY: centroidY,
  };
}
